import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import {
    DEFAULT_ID_TYPE,
    mapPaisesToSelectOptions,
    mapMunicipiosToSelectOptions,
    getDefaultColombiaCountryValue,
} from '../../utils/locationFormHelpers';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import esLocale from '@fullcalendar/core/locales/es';
import moment from 'moment-timezone';
import { parseAppointmentDate, toAppointmentUTC } from '../../utils/appointmentDate';
import TableDocuments from './TableDocuments';
import apiClient from '../../utils/axiosPetition';
import { alertaGeneral } from '../../utils/alertas';
import Contenedor from '../GlobalComponents/Contenedor';
import SvgIcon from '../../utils/Icon';
import { ReactComponent as Buscar } from '../../assets/icons/lupa.svg';
import { ReactComponent as UsuarioIcon } from "../../assets/icons/usuario.svg";
import { ReactComponent as Perfil } from "../../assets/icons/perfilUsuario.svg";
import { ReactComponent as Calendario } from "../../assets/icons/calendario.svg";
import { ReactComponent as EditarIcon } from "../../assets/icons/Preescribir.svg";
import { ReactComponent as AgendarCitaIcon } from "../../assets/icons/citas.svg";
import { ReactComponent as Password } from "../../assets/icons/contraseña.svg";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import InputFile from '../../utils/InputFile';
import Modal from 'react-modal';
import Cargando from '../../utils/Cargando';
import { useDataUser } from '../../context/dataUserContext';
import doctorService from '../../api/doctorService';
Modal.setAppElement('#root');


const PatientComponent = () => {
    const { clinicId } = useDataUser();

    const [showForm, setShowForm] = useState(false);
    const [patients, setPatients] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [menuVisible, setMenuVisible] = useState(false);
    const [showCalendar, setShowCalendar] = useState(false);
    const [showAppointmentModal, setShowAppointmentModal] = useState(false);
    const [appointmentNotes, setAppointmentNotes] = useState('');
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [selectedService, setSelectedService] = useState('');
    const [selectedDoctor, setSelectedDoctor] = useState(null);
    const [doctors, setDoctors] = useState([]);
    const [appointmentDate, setAppointmentDate] = useState('');
    const [paises, setPaises] = useState([]);
    const [especialidades, setEspecialidades] = useState([]);
    const [loadingEspecialidades, setLoadingEspecialidades] = useState(false);
    const [clinicServices, setClinicServices] = useState([]);

    const [appointments, setAppointments] = useState([]);
    const [loadingAppointments, setLoadingAppointments] = useState(true);
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [showProfile, setShowProfile] = useState(false);
    const [filesToEdit, setFilesToEdit] = useState([]);

    const fetchPatients = async () => {
        try {
            const response = await apiClient.get(`/api/clinic/getPatients/${clinicId}`);

            setPatients(response.data);
        } catch (error) {
            console.error('Error fetching patients:', error);
        }
    };

    const fetchPaises = async () => {
        try {
            const response = await apiClient.get(`/api/clinic/getPaises`);

            setPaises(response.data);
        } catch (error) {
            console.error('Error fetching países:', error);
        }
    };
    useEffect(() => {
        fetchPaises();
    }, []);

    const fetchDoctorsByService = async (service) => {
        try {
            if (!service) {
                setDoctors([]);
                return;
            }
            // Enviar el servicio tal como viene del backend (con espacios, sin códigos)
            // El backend se encargará de normalizarlo y buscar con diferentes formatos
            const response = await apiClient.get(`/api/clinic/getDoctorsByService/${clinicId}?service=${encodeURIComponent(service)}`);
            setDoctors(response.data);
        } catch (error) {
            console.error('Error fetching doctors:', error);
            setDoctors([]);
        }
    };

    const fetchClinicServices = async () => {
        try {
            // Obtener todos los doctores de la clínica para extraer sus especialidades
            const response = await apiClient.get(`/api/clinic/getDoctors/${clinicId}`);
            if (response.data && Array.isArray(response.data)) {
                // Obtener especialidades únicas de los doctores
                const uniqueSpecialties = [];
                const seenSpecialties = new Set();
                
                response.data.forEach(doctor => {
                    if (doctor.service) {
                        // El servicio viene formateado desde el backend (sin códigos, con espacios)
                        // Normalizar para comparación: convertir a minúsculas y quitar espacios extra
                        const normalizedService = doctor.service.toLowerCase().trim().replace(/\s+/g, ' ');
                        
                        if (!seenSpecialties.has(normalizedService)) {
                            seenSpecialties.add(normalizedService);
                            // Formatear el nombre de la especialidad para mostrarlo de manera legible
                            const formattedLabel = formatServiceName(doctor.service);
                            // Usar el servicio formateado como value (con espacios, sin códigos)
                            uniqueSpecialties.push({
                                value: doctor.service, // Mantener el formato que viene del backend
                                label: formattedLabel
                            });
                        }
                    }
                });
                
                // Ordenar alfabéticamente por nombre
                uniqueSpecialties.sort((a, b) => a.label.localeCompare(b.label));
                
                setClinicServices(uniqueSpecialties);
            }
        } catch (error) {
            console.error('Error fetching clinic specialties:', error);
            // Fallback a especialidades básicas si hay error
            setClinicServices([
                { value: 'medicina general', label: 'Médico general' },
                { value: 'medicina familiar', label: 'Médico familiar' }
            ]);
        }
    };

    const formatServiceName = (service) => {
        if (!service) return '';
        
        // Remover códigos numéricos al inicio si existen
        let formatted = service.replace(/^\d+\s*/, '').trim();
        
        // Reemplazar guiones bajos con espacios
        formatted = formatted.replace(/_/g, ' ');
        
        // Capitalizar primera letra de cada palabra
        return formatted
            ? formatted.charAt(0).toLocaleUpperCase('es-CO') + formatted.slice(1).toLocaleLowerCase('es-CO')
            : '';
    };

    const handleCancel = () => {
        setShowAppointmentModal(false);
        setSelectedService('');
        setSelectedDoctor(null);
        setDoctors([]);
        setAppointmentDate('');
        setAppointmentNotes('');
        setClinicServices([]);
    };

    const fetchAppointments = async () => {
        try {
            setLoadingAppointments(true);
            const response = await apiClient.get(`/api/clinic/getAppointments/${selectedPatient._id}`);

            const appointmentsData = response.data.map(appointment => {
                const citaDate = parseAppointmentDate(appointment.date);

                // Incluimos el nombre del doctor
                return {
                    title: 'Cita de control',
                    start: citaDate.toISOString(),
                    allDay: false,
                    backgroundColor: '#000aff',
                    borderColor: '#000aff',
                    extendedProps: {
                        notes: appointment.notes,
                        startTime: citaDate.format('HH:mm'),
                        doctorName: appointment.doctor.fullName
                    }
                };
            });

            setAppointments(appointmentsData);
        } catch (error) {
            console.error('Error fetching appointments:', error);
            alertaGeneral({
                titulo: "Error",
                messageHtml: "No se pudieron cargar las citas del usuario.",
                isError: true
            });
        } finally {
            setLoadingAppointments(false);
        }
    };

    useEffect(() => {
        if (!selectedPatient || !showCalendar) return;
        fetchAppointments();
    }, [showCalendar, selectedPatient]);

    useEffect(() => {
        fetchPatients();
    }, []);

    const handleShowForm = () => {
        setShowForm(true);
    };

    const handleGoBack = () => {
        setAppointments([]);
        setSelectedPatient(null);
        setShowForm(false);
        setShowCalendar(false); // Oculta el calendario al volver
        setShowChangePassword(false);
        setShowProfile(false);
    };

    const opcionesPaises = mapPaisesToSelectOptions(paises);

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };
    const handleEventClick = (info) => {
        setSelectedEvent(info.event);
    };

    const handleCloseModal = () => {
        setSelectedEvent(null);
    };
    const filteredPatients = patients.filter(patient => {
        const searchTermLower = searchTerm.toLowerCase();
        return (
            patient.firstName?.toLowerCase().includes(searchTermLower) ||
            patient.firstLastName?.toLowerCase().includes(searchTermLower) ||
            patient.email?.toLowerCase().includes(searchTermLower) ||
            patient.cellNumber?.toLowerCase().includes(searchTermLower) ||
            patient.idNumber?.toLowerCase().includes(searchTermLower)
        );
    });

    const toggleMenu = (patient) => {
        setSelectedPatient(patient);
        // setFilesToEdit([]);
        setMenuVisible((prevVisible) => !prevVisible);
    };

    const handleMenuOptionClick = (option) => {
        if (option === 'Eliminar Usuario') {
            handleDeletePatient();
        }
        if (option === 'Calendario') {
            setShowCalendar(true);
        }
        if (option === 'Agendar Cita') {
            setShowAppointmentModal(true);
            loadSpecialties();
            fetchClinicServices(); // Cargar servicios cuando se abre el modal
        }
        if (option === 'Cambiar Contraseña') {
            setShowChangePassword(true);
        }
        if (option === 'Perfil') {
            setShowProfile(true);
        }
    };

    // Cargar especialidades desde el servicio
    const loadSpecialties = async () => {
        try {
            setLoadingEspecialidades(true);
            const specialties = await doctorService.getAvailableSpecialties();
            setEspecialidades(specialties);
        } catch (error) {
            console.error('Error cargando especialidades:', error);
            // Fallback a especialidades predefinidas
            setEspecialidades([
                { value: 'medicina_general', label: 'Médico general' },
                { value: 'medicina_familiar', label: 'Médico familiar' },
                { value: 'cardiologia', label: 'Cardiología' },
                { value: 'dermatologia', label: 'Dermatología' },
                { value: 'endocrinologia', label: 'Endocrinología' },
                { value: 'gastroenterologia', label: 'Gastroenterología' },
                { value: 'ginecologia', label: 'Ginecología' },
                { value: 'neurologia', label: 'Neurología' },
                { value: 'oftalmologia', label: 'Oftalmología' },
                { value: 'ortopedia', label: 'Ortopedia' },
                { value: 'pediatria', label: 'Pediatría' },
                { value: 'psicologia', label: 'Psicología' },
                { value: 'psiquiatria', label: 'Psiquiatría' },
                { value: 'nutricion', label: 'Nutrición' },
                { value: 'terapia_fisica', label: 'Terapia física' },
                { value: 'fonoaudiologia', label: 'Fonoaudiología' },
                { value: 'trabajo_social', label: 'Trabajo social' },
                { value: 'enfermeria', label: 'Enfermería' },
                { value: 'auxiliar_enfermeria', label: 'Auxiliar de enfermería' }
            ]);
        } finally {
            setLoadingEspecialidades(false);
        }
    };

    const handleDeletePatient = async () => {
        try {
            alertaGeneral({
                titulo: "¿Estás seguro?",
                messageHtml: "Una vez eliminado, no podrás recuperar esta información.",
                confirmButtonText: "Sí, eliminar",
                cancelButton: true,
                cancelButtonText: "Cancelar",
                isWarning: true
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const response = await apiClient.put(`/api/clinic/deletePatient/${selectedPatient._id}`);

                    if (response.status === 200) {
                        alertaGeneral({
                            titulo: "Eliminado",
                            messageHtml: "El usuario ha sido eliminado exitosamente.",
                            isError: true
                        });
                        setPatients(patients.filter(patient => patient._id !== selectedPatient._id));
                    } else {
                        alertaGeneral({
                            titulo: "Error",
                            messageHtml: "No se pudo eliminar el usuario. Inténtalo de nuevo.",
                            isError: true
                        });
                    }
                }
            })
        } catch (error) {
            console.error('Error deleting patient:', error);
            alertaGeneral({
                titulo: "Error",
                messageHtml: "Ocurrió un error al eliminar el usuario.",
                isError: true
            });
        }
    };

    const handleScheduleAppointment = async () => {
        try {
            const formattedDate = toAppointmentUTC(appointmentDate);

            // Verifica si el doctor está asignado
            console.log("Selected Doctor:", selectedDoctor);

            const response = await apiClient.post(`/api/clinic/scheduleAppointment`,
                {
                    patientId: selectedPatient._id,
                    date: formattedDate,
                    notes: appointmentNotes,
                    doctorId: selectedDoctor.value,
                    service: selectedService,
                }
            );

            if (response.status === 200) {
                alertaGeneral({
                    titulo: "Cita Agendada",
                    messageHtml: "La cita ha sido agendada exitosamente.",
                });
                setShowAppointmentModal(false);
                setAppointmentDate('');
                setAppointmentNotes('');
                setDoctors([]);
                setSelectedDoctor(null);
                setSelectedService('');
                setClinicServices([]);
            } else {
                alertaGeneral({
                    titulo: "Error",
                    messageHtml: "No se pudo agendar la cita. Inténtalo de nuevo.",
                    isError: true
                });
            }
        } catch (error) {
            console.error('Error scheduling appointment:', error);
            const conflict = error.response?.status === 409;
            alertaGeneral({
                titulo: conflict ? 'Horario no disponible' : 'Error',
                messageHtml: error.response?.data?.message || 'Ocurrió un error al agendar la cita.',
                isError: true,
            });
        }
    };

    const doctorOptions = doctors.map(doctor => ({
        value: doctor._id,
        label: `${doctor.fullName} | Documento | ${doctor.idNumber || 'N/A'}`
    }));

    const handleEditPatient = async () => {
        try {
            const dataPatientToSend = new FormData();
            for (const key in selectedPatient) {
                dataPatientToSend.append(key, selectedPatient[key]);
            }
            for (const key in filesToEdit) {
                dataPatientToSend.append(key, filesToEdit[key]);
            }

            const response = await apiClient.put(`/api/clinic/editPatient/${selectedPatient._id}`, dataPatientToSend);

            if (response.status === 200) {
                alertaGeneral({
                    titulo: "Usuario Editado",
                    messageHtml: "El usuario ha sido editado exitosamente.",
                });
                setShowProfile(false);
                fetchPatients();

            } else {
                alertaGeneral({
                    titulo: "Error editando usuario",
                    messageHtml: "El usuario no pudo ser editado",
                    isError: true
                });
            }
        } catch (error) {
            console.error('Error updating patient information:', error);
            alertaGeneral({
                titulo: "Error editando usuario",
                messageHtml: "El usuario no pudo ser editado",
                isError: true
            });

        }
    };

    const lstDocumentsExists = [
        { nameToSave: 'foto_perfil', name: 'Foto Del Usuario', url: selectedPatient?.urlPictureProfile || '', isEdit: true },
        { nameToSave: 'cedulaPDF', name: 'Documento de Identidad', url: selectedPatient?.urlFileDocument || '', isEdit: true },
    ]


    if (showProfile) {
        return (
            <Contenedor icon={Perfil} title={`Editar perfil del usuario ${selectedPatient.firstName} ${selectedPatient.firstLastName}`}>
                <div className="flex justify-end mb-4">
                    <button
                        onClick={handleGoBack}
                        className="button-gray"
                    >
                        Volver
                    </button>
                </div>
                <div className="max-w-full">
                    <form>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            {/* Personal Information Fields */}
                            <div className="col-span-1">
                                <label className="form-label">Nombre</label>
                                <input
                                    type="text"
                                    value={selectedPatient.firstName}
                                    onChange={(e) => setSelectedPatient({ ...selectedPatient, firstName: e.target.value })}
                                    className="form-input"
                                />
                            </div>
                            <div className="col-span-1">
                                <label className="form-label">Segundo Nombre</label>
                                <input
                                    type="text"
                                    value={selectedPatient.secondName}
                                    onChange={(e) => setSelectedPatient({ ...selectedPatient, secondName: e.target.value })}
                                    className="form-input"
                                />
                            </div>
                            <div className="col-span-1">
                                <label className="form-label">Primer Apellido</label>
                                <input
                                    type="text"
                                    value={selectedPatient.firstLastName}
                                    onChange={(e) => setSelectedPatient({ ...selectedPatient, firstLastName: e.target.value })}
                                    className="form-input"
                                />
                            </div>
                            <div className="col-span-1">
                                <label className="form-label">Segundo Apellido</label>
                                <input
                                    type="text"
                                    value={selectedPatient.secondLastName}
                                    onChange={(e) => setSelectedPatient({ ...selectedPatient, secondLastName: e.target.value })}
                                    className="form-input"
                                />
                            </div>

                            <div className="col-span-1">
                                <label className="form-label">Correo Electrónico</label>
                                <input
                                    type="email"
                                    value={selectedPatient.email}
                                    onChange={(e) => setSelectedPatient({ ...selectedPatient, email: e.target.value })}
                                    className="form-input"
                                />
                            </div>
                            <div className="col-span-1">
                                <label className="form-label">Número de Teléfono</label>
                                <input
                                    type="tel"
                                    value={selectedPatient.cellNumber}
                                    onChange={(e) => setSelectedPatient({ ...selectedPatient, cellNumber: e.target.value })}
                                    className="form-input"
                                />
                            </div>


                            <div className="col-span-1">
                                <label className="form-label">Calle</label>
                                <input
                                    type="text"
                                    value={selectedPatient.street}
                                    onChange={(e) => setSelectedPatient({ ...selectedPatient, street: e.target.value })}
                                    className="form-input"
                                />
                            </div>
                            <div className="col-span-1">
                                <label className="form-label">Número Exterior</label>
                                <input
                                    type="text"
                                    value={selectedPatient.exteriorNumber}
                                    onChange={(e) => setSelectedPatient({ ...selectedPatient, exteriorNumber: e.target.value })}
                                    className="form-input"
                                />
                            </div>
                            <div className="col-span-1">
                                <label className="form-label">Número Interior</label>
                                <input
                                    type="text"
                                    value={selectedPatient.interiorNumber}
                                    onChange={(e) => setSelectedPatient({ ...selectedPatient, interiorNumber: e.target.value })}
                                    className="form-input"
                                />
                            </div>
                            <div className="col-span-1">
                                <label className="form-label">Barrio</label>
                                <input
                                    type="text"
                                    value={selectedPatient.neighborhood}
                                    onChange={(e) => setSelectedPatient({ ...selectedPatient, neighborhood: e.target.value })}
                                    className="form-input"
                                />
                            </div>

                            {/* Identification Documents Fields */}
                            <div className="col-span-1">
                                <label className="form-label">Tipo de Identificación</label>
                                <input
                                    type="text"
                                    value={selectedPatient.idType}
                                    onChange={(e) => setSelectedPatient({ ...selectedPatient, idType: e.target.value })}
                                    className="form-input"
                                />
                            </div>
                            <div className="col-span-1">
                                <label className="form-label">Número de Identificación</label>
                                <input
                                    type="text"
                                    value={selectedPatient.idNumber}
                                    onChange={(e) => setSelectedPatient({ ...selectedPatient, idNumber: e.target.value })}
                                    className="form-input"
                                />
                            </div>


                            {/* Insurance and Caregiver Information Fields */}
                            <div className="col-span-1">
                                <label className="form-label">¿Tiene Seguro Médico?</label>
                                <select
                                    value={selectedPatient.hasMedicalInsurance}
                                    onChange={(e) => setSelectedPatient({ ...selectedPatient, hasMedicalInsurance: e.target.value })}
                                    className="form-input"
                                >
                                    <option value="No">No</option>
                                    <option value="Si">Sí</option>

                                </select>
                            </div>
                            {selectedPatient.hasMedicalInsurance === 'Si' && (
                                <>
                                    <div className="col-span-1">
                                        <label className="form-label">Nombre del Seguro</label>
                                        <input
                                            type="text"
                                            value={selectedPatient.insuranceName}
                                            onChange={(e) => setSelectedPatient({ ...selectedPatient, insuranceName: e.target.value })}
                                            className="form-input"
                                        />
                                    </div>
                                    <div className="col-span-1">
                                        <label className="form-label">Número de Seguro</label>
                                        <input
                                            type="text"
                                            value={selectedPatient.insuranceNumber}
                                            onChange={(e) => setSelectedPatient({ ...selectedPatient, insuranceNumber: e.target.value })}
                                            className="form-input"
                                        />
                                    </div>
                                </>
                            )}
                            <div className="col-span-1">
                                <label className="form-label">¿Tiene Cuidador?</label>
                                <select
                                    value={selectedPatient.hasCarer}
                                    onChange={(e) => setSelectedPatient({ ...selectedPatient, hasCarer: e.target.value })}
                                    className="form-input"
                                >
                                    <option value="No">No</option>
                                    <option value="Si">Sí</option>
                                </select>

                            </div>
                            {selectedPatient.hasCarer === 'Si' && (
                                <>
                                    <div className="col-span-1">
                                        <label className="form-label">Nombre del Cuidador</label>
                                        <input
                                            type="text"
                                            value={selectedPatient.carerFirstName}
                                            onChange={(e) => setSelectedPatient({ ...selectedPatient, carerFirstName: e.target.value })}
                                            className="form-input"
                                        />
                                    </div>
                                    <div className="col-span-1">
                                        <label className="form-label">Segundo Nombre del Cuidador</label>
                                        <input
                                            type="text"
                                            value={selectedPatient.carerSecondName}
                                            onChange={(e) => setSelectedPatient({ ...selectedPatient, carerSecondName: e.target.value })}
                                            className="form-input"
                                        />
                                    </div>
                                    <div className="col-span-1">
                                        <label className="form-label">Apellido Paterno del Cuidador</label>
                                        <input
                                            type="text"
                                            value={selectedPatient.carerFirstLastName}
                                            onChange={(e) => setSelectedPatient({ ...selectedPatient, carerFirstLastName: e.target.value })}
                                            className="form-input"
                                        />
                                    </div>
                                    <div className="col-span-1">
                                        <label className="form-label">Apellido Materno del Cuidador</label>
                                        <input
                                            type="text"
                                            value={selectedPatient.carerSecondLastName}
                                            onChange={(e) => setSelectedPatient({ ...selectedPatient, carerSecondLastName: e.target.value })}
                                            className="form-input"
                                        />
                                    </div>
                                    <div className="col-span-1">
                                        <label className="form-label">Relación con el Usuario</label>
                                        <input
                                            type="text"
                                            value={selectedPatient.carerRelationship}
                                            onChange={(e) => setSelectedPatient({ ...selectedPatient, carerRelationship: e.target.value })}
                                            className="form-input"
                                        />
                                    </div>
                                    <div className="col-span-1">
                                        <label className="form-label">Tipo de Identificación del Cuidador</label>
                                        <input
                                            type="text"
                                            value={selectedPatient.carerIdType}
                                            onChange={(e) => setSelectedPatient({ ...selectedPatient, carerIdType: e.target.value })}
                                            className="form-input"
                                        />
                                    </div>
                                    <div className="col-span-1">
                                        <label className="form-label">Número de Identificación del Cuidador</label>
                                        <input
                                            type="text"
                                            value={selectedPatient.carerIdNumber}
                                            onChange={(e) => setSelectedPatient({ ...selectedPatient, carerIdNumber: e.target.value })}
                                            className="form-input"
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="flex justify-end mt-4">
                            <button
                                type="button"
                                onClick={handleEditPatient}
                                className="button-send"
                            >
                                Guardar cambios
                            </button>
                        </div>
                    </form>
                    <TableDocuments
                        lstDocuments={lstDocumentsExists ? lstDocumentsExists : null}
                        filesToEdit={filesToEdit}
                        setFilesToEdit={setFilesToEdit}
                    />
                </div>
            </Contenedor>
        );
    }

    if (showCalendar) {
        return (
            <Contenedor icon={Calendario} title={`Calendario de citas de ${selectedPatient.firstName} ${selectedPatient.firstLastName}`}>
                <div className="flex justify-end mb-4">
                    <button
                        onClick={handleGoBack}
                        className="button-gray"
                    >
                        Volver
                    </button>
                </div>
                {loadingAppointments ? (
                    <Cargando />
                ) : (
                    <>
                        <main className="flex-grow flex items-center justify-center">
                            <div className="w-full max-w-3xl bg-white">
                                <FullCalendar
                                    plugins={[dayGridPlugin, interactionPlugin]}
                                    initialView="dayGridMonth"
                                    events={appointments} // Asegúrate de que appointments tenga el campo doctorName
                                    locales={[esLocale]}
                                    locale="es"
                                    timeZone="local"
                                    dayCellClassNames={(date) =>
                                        date.date.getDate() === new Date().getDate() &&
                                            date.date.getMonth() === new Date().getMonth()
                                            ? 'current-day'
                                            : ''
                                    }
                                    eventContent={(eventInfo) => {
                                        const startTime = parseAppointmentDate(eventInfo.event.start).format('h:mm A');

                                        return (
                                            <div>
                                                <div className="font-semibold text-white text-xs">{eventInfo.event.title}</div>
                                                <div className=" text-white text-xs ">{startTime}</div>

                                            </div>
                                        );
                                    }}
                                    eventClick={(info) => handleEventClick(info)}
                                />
                            </div>
                        </main>
                        {selectedEvent && (
                            <Modal
                                isOpen={selectedEvent}
                                onRequestClose={handleCloseModal}
                                className="w-[300px] mx-auto bg-white p-4 rounded-lg shadow-lg text-center border border-[#6e787aff] focus:outline-none"
                                overlayClassName="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-[20]"
                            >
                                <h2 className="text-2xl text-[#205087ff] font-bold">{selectedEvent.title}</h2>
                                <hr className="h-[1px] w-full bg-[#205087ff] mb-2" />

                                <div className="space-y-2">
                                    <p className="text-left text-[#70706eff] font-semibold">
                                        Fecha: <span className="font-medium">{parseAppointmentDate(selectedEvent.start).format('YYYY-MM-DD')}</span>
                                    </p>
                                    <p className="text-left text-[#70706eff] font-semibold">
                                        Hora: <span className="font-medium">{parseAppointmentDate(selectedEvent.start).format('HH:mm')}</span>
                                    </p>
                                    <p className="text-left text-[#70706eff] font-semibold">
                                        Doctor: <span className="font-medium">{selectedEvent.extendedProps.doctorName}</span>
                                    </p>
                                    <p className="text-left text-[#70706eff] font-semibold">
                                        Notas: <span className="font-medium">{selectedEvent.extendedProps.notes}</span>
                                    </p>
                                </div>
                                <div className="flex justify-end mt-2">
                                    <button
                                        onClick={handleCloseModal}
                                        className="button-gray"
                                    >
                                        Cerrar
                                    </button>
                                </div>
                            </Modal>
                        )}
                        <style>
                            {`
                    .fc-event {
                        background-color: #1f94c2ff !important;
                        border: 1px solid #3090b3ff;
                        padding: 2px;
                        cursor: pointer !important;
                    }
                    .fc-daygrid-day {
                        visibility: visible;
                    }
                    .current-day {
                        background-color: #e7e6e6 !important;
                        border: 2px solid #fbc02d;
                    }
                    `}
                        </style>
                    </>
                )}
            </Contenedor>
        );
    }

    const closeChangePasswordModal = () => {
        setShowChangePassword(false);
    };

    const handleChangePassword = async () => {
        try {

            const response = await apiClient.post(`/api/clinic/changePasswordPatient`, {
                username: selectedPatient.email,
                newPassword: newPassword
            });

            if (response.status === 200) {
                alertaGeneral({
                    titulo: "Contraseña Cambiada",
                });
                setNewPassword('');
                closeChangePasswordModal();
            } else {
                alertaGeneral({
                    titulo: "Contraseña actual incorrecta",
                    isError: true
                });
            }

        } catch (error) {

        }
    };
    return (
        <div>
            {!showForm ? (
                <Contenedor icon={UsuarioIcon} title="Usuarios">
                    <div className="flex flex-col md:flex-row w-full justify-start md:justify-between items-center gap-2 mb-6">
                        <div className="flex items-center">
                            <span className="flex bg-[#1f94c2ff] text-white p-2">
                                <SvgIcon Icon={Buscar} className={"w-5 h-5"} />
                            </span>
                            <input type="text"
                                placeholder="Buscar usuario"
                                className="w-fit p-[5px] border-t border-r border-b border-[#6e787aff] focus:outline-none"
                                value={searchTerm}
                                onChange={handleSearchChange}
                            />
                        </div>
                        <button
                            onClick={handleShowForm}
                            className="button-add"
                        >
                            Agregar Usuario
                        </button>
                    </div>

                    <div className="overflow-x-auto max-h-[500px]">
                        <table className="relative w-full h-full">
                            <thead className="sticky top-0 z-[1] bg-white">
                                <tr className="font-semibold text-[#205087ff]">
                                    <th className="table-header">Nombre</th>
                                    <th className="table-header">Correo Electrónico</th>
                                    <th className="table-header">Número de Celular</th>
                                    <th className="table-header">Tipo de ID</th>
                                    <th className="table-header">No. Identificación</th>
                                    <th className="table-header">Acciones</th>
                                </tr>

                                <tr>
                                    <th colSpan={6} className="p-0">
                                        <div className="h-[1px] bg-[#205087ff]"></div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredPatients.map((patient) => (
                                    <tr key={patient._id}>
                                        <td className="table-data">
                                            {patient.firstName} {patient.firstLastName}
                                        </td>
                                        <td className="table-data text-nowrap">{patient.email}</td>
                                        <td className="table-data">{patient.cellNumber}</td>
                                        <td className="table-data uppercase">{patient.idType}</td>
                                        <td className="table-data">{patient.idNumber}</td>
                                        <td className="table-data" onClick={() => toggleMenu(patient)}>
                                            <div className="grid grid-cols-3 gap-x-5 gap-y-2 pr-2">
                                                <SvgIcon title="Editar" Icon={EditarIcon} className="text-[#1f94c2ff] w-5 h-5 cursor-pointer transform hover:scale-110" onClick={() => handleMenuOptionClick('Perfil')} />
                                                <SvgIcon title="Cambiar contraseña" Icon={Password} className="text-[#205087ff] w-5 h-5 cursor-pointer transform hover:scale-110" onClick={() => handleMenuOptionClick('Cambiar Contraseña')} />
                                                <FontAwesomeIcon title="Eliminar" icon={faTrashAlt} className="text-[#1f94c2ff] w-5 h-5 cursor-pointer transform hover:scale-110" onClick={() => handleMenuOptionClick('Eliminar Usuario')} />
                                                {/* Calendario y agendar cita */}
                                                <SvgIcon title="Ver calendario" Icon={Calendario} className="text-[#205087ff] w-5 h-5 cursor-pointer transform hover:scale-110" onClick={() => handleMenuOptionClick('Calendario')} />
                                                <SvgIcon title="Agendar cita" Icon={AgendarCitaIcon} className="text-[#1f94c2ff] w-5 h-5 cursor-pointer transform hover:scale-110" onClick={() => handleMenuOptionClick('Agendar Cita')} />
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                </Contenedor>
            ) : (
                <Patient onGoBack={handleGoBack} fetchPatients={fetchPatients} />

            )}



            {showChangePassword && (
                <Modal
                    isOpen={showChangePassword}
                    onRequestClose={closeChangePasswordModal}
                    className="w-[420px] mx-auto bg-white p-6 rounded-lg shadow-lg text-center border border-[#6e787aff] focus:outline-none"
                    overlayClassName="fixed inset-0 flex items-center justify-center bg-white bg-opacity-75 z-[20]"
                >
                    <h2 className="text-lg text-left text-[#205087ff] font-bold mb-4">CAMBIAR CONTRASEÑA PARA {selectedPatient.email}</h2>

                    <div className="flex flex-col justify-start">
                        <div className="flex items-center mb-4 gap-2">
                            <label className="form-label text-nowrap">Nueva contraseña:</label>
                            <input
                                type="password"
                                className="py-1 form-input"
                                placeholder='******'
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="flex justify-center gap-3">
                        <button
                            onClick={() => setShowChangePassword(false)}
                            className="button-gray"
                        >
                            Cancelar
                        </button>
                        <button
                            className="button-send"
                            onClick={handleChangePassword}
                        >
                            Cambiar contraseña
                        </button>
                    </div>
                </Modal>
            )}

            {/* Modal de Agendar Cita */}
            {showAppointmentModal && (
                <div className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg">
                        <h2 className="text-lg font-bold mb-4">
                            Agendar cita para {selectedPatient.firstName} {selectedPatient.firstLastName}
                        </h2>

                        {/* Service Selection */}
                        <label className="form-input mb-2">
                            Selecciona servicio:
                            <select
                                value={selectedService}
                                onChange={(e) => {
                                    setSelectedService(e.target.value);
                                    fetchDoctorsByService(e.target.value); // Fetch doctors when service changes
                                }}
                                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                disabled={loadingEspecialidades}
                            >
                                <option value="">{loadingEspecialidades ? 'Cargando especialidades...' : 'Selecciona un servicio'}</option>
                                {especialidades.map((esp) => (
                                    <option key={esp.value} value={esp.value}>
                                        {esp.label}
                                    </option>
                                ))}
                            </select>
                        </label>

                        {/* Doctor Selection */}
                        <label className="form-input mb-2 mt-4">
                            Selecciona doctor:
                            <Select
                                value={selectedDoctor}
                                onChange={(option) => setSelectedDoctor(option)}
                                options={doctorOptions}
                                isDisabled={!doctors.length}
                                placeholder="Selecciona un doctor"
                            />
                        </label>

                        {/* Appointment Date */}
                        <label className="form-input mb-2 mt-4">
                            Fecha de la cita:
                            <input
                                type="datetime-local"
                                value={appointmentDate}
                                onChange={(e) => setAppointmentDate(e.target.value)}
                                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                            />
                        </label>

                        {/* Appointment Notes */}
                        <label className="form-input mb-2 mt-4">
                            Motivo de la consulta:
                            <textarea
                                value={appointmentNotes}
                                onChange={(e) => setAppointmentNotes(e.target.value)}
                                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                                rows="4"
                                placeholder="Añadir Motivo de la consulta..."
                            />
                        </label>

                        <div className="flex justify-end mt-4">
                            <button
                                onClick={handleCancel}
                                className="px-4 py-2 mr-2 bg-gray-300 text-gray-700 font-semibold rounded-md shadow-md hover:bg-gray-400"
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={handleScheduleAppointment}
                                className="px-4 py-2 bg-gradient-to-r from-blue-400 via-blue-600 to-blue-900 text-white font-semibold rounded-md shadow-md hover:bg-blue-600"
                            >
                                Agendar
                            </button>
                        </div>
                    </div>
                </div>
            )}


        </div>
    );
};



const Patient = ({ onGoBack, fetchPatients }) => {
    const { clinicId } = useDataUser();
    const [departments, setDepartments] = useState([]);
    const [cities, setCities] = useState([]);
    const [loading, setLoading] = useState(false);

    const [selectedAseguradora, setSelectedAseguradora] = useState(null);
    const [selectedOcupacion, setSelectedOcupacion] = useState(null);

    const [aseguradoraOptions, setAseguradoraOptions] = useState([]);
    const [ocupacionOptions, setOcupacionOptions] = useState([]);
    const [paises, setPaises] = useState([]);

    const [formData, setFormData] = useState({
        foto_perfil: '',
        dob: '',
        birthCountry: '',
        residenceCountry: '',
        municipio: '',
        city: '',
        neighborhood: '',
        firstName: '',
        secondName: '',
        firstLastName: '',
        estadoCivil: '',
        zonaUbicacion: '',
        secondLastName: '',
        grupoSanguineo: '',
        rh: '',
        address: '',
        grupoEtnico: '',
        gender: '',
        sex: '',
        condicionDesplazamiento: '',
        escolaridad: '',
        cellNumber: '',
        cellNumber1: '',
        email: '',
        idType: DEFAULT_ID_TYPE,
        idNumber: '',
        tipoUsuario: '',
        cedulaPDF: '',
        hasMedicalInsurance: 'no',
        insuranceName: '',
        aseguradora: '',
        insuranceNumber: '',
        hasCarer: 'no',
        ocupacion: '',
        carerFirstName: '',
        carerSecondName: '',
        carerFirstLastName: '',
        carerSecondLastName: '',
        carerRelationship: '',
        carerIdType: '',
        carerIdNumber: '',
    });
    useEffect(() => {

        // Fetch departments when modal opens
        const fetchDepartments = async () => {
            try {
                const response = await apiClient.get(`/api/clinic/departments`);
                setDepartments(response.data);
            } catch (error) {
                console.error('Error fetching departments:', error);
            }
        };

        fetchDepartments();

    }, []);

    const fetchPaises = async () => {
        try {
            const response = await apiClient.get(`/api/clinic/getPaises`);
            setPaises(response.data);
        } catch (error) {
            console.error('Error fetching países:', error);
        }
    };

    // Llama a fetchPaises cuando el componente se monte
    useEffect(() => {
        fetchPaises();
    }, []);

    useEffect(() => {
        if (!paises.length) return;
        const defaultCountry = getDefaultColombiaCountryValue(paises);
        if (!defaultCountry) return;

        setFormData((prev) => {
            const next = { ...prev };
            let changed = false;

            if (!prev.birthCountry) {
                next.birthCountry = defaultCountry;
                changed = true;
            }
            if (!prev.residenceCountry) {
                next.residenceCountry = defaultCountry;
                changed = true;
            }

            return changed ? next : prev;
        });
    }, [paises]);

    const fetchAseguradoraOptions = async (query) => {
        setLoading(true);

        try {
            const response = await apiClient.get(`/api/clinic/searchAseguradora`,
                {
                    params: { query }
                }
            );

            const options = response.data.map((med) => ({
                value: med.Os,         // Código CIE-10
                label: med.Nombre         // Nombre de la enfermedad

            }));

            setAseguradoraOptions(options);
        } catch (error) {
            console.error('Error al obtener las Aseguradoras:', error);
        } finally {
            setLoading(false);
        }
    };
    const fetchOcupacionOptions = async (query) => {
        setLoading(true);

        try {
            const response = await apiClient.get(`/api/clinic/searchOcupacion`,
                {
                    params: { query }
                }
            );

            const options = response.data.map((med) => ({
                value: med.Indice,
                label: med.Detalle

            }));

            setOcupacionOptions(options);
        } catch (error) {
            console.error('Error al obtener las Ocupaciones:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (formData.department) {
            // Fetch municipalities when a department is selected
            const fetchCities = async () => {
                if (formData.department) {
                    try {
                        const response = await apiClient.get(`/api/clinic/cities/${formData.department}`);
                        setCities(response.data);
                    } catch (error) {
                        console.error('Error fetching cities:', error);
                    }
                }
            };

            fetchCities();
        } else {
            setCities([]);
        }
    }, [formData.department]);

    const handleDepartmentChange = (event) => {
        const selectedId = event.target.value;
        const selectedDepartment = departments.find(dept => dept._id === selectedId);

        setFormData({
            ...formData,
            department: selectedId, // ID del departamento
            departmentName: selectedDepartment ? selectedDepartment.departamento : '', // Nombre del departamento
        });
    };
    const handleChange = (e) => {
        const { name, value, type, files } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'file' ? files[0] : value,
        }));
    };

    const handleAseguradoraChange = (selectedOption) => {
        setSelectedAseguradora(selectedOption); // Mantiene el valor seleccionado en su estado individual
        setFormData({
            ...formData,
            aseguradora: selectedOption ? selectedOption.label : '', // Actualiza insuranceName en formData
        });
    };
    const handleOcupacionChange = (selectedOption) => {
        setSelectedOcupacion(selectedOption); // Mantiene el valor seleccionado en su estado individual
        setFormData({
            ...formData,
            ocupacion: selectedOption ? selectedOption.label : '', // Actualiza insuranceName en formData
        });
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        const formDataToSend = new FormData();
        for (const key in formData) {
            formDataToSend.append(key, formData[key]);
        }
        formDataToSend.append('clinicId', clinicId);
        try {
            const response = await apiClient.post(`/api/clinic/patientInfo`, formDataToSend);
            if (response.status >= 200 && response.status < 300) {
                alertaGeneral({
                    titulo: "¡Usuario creado con éxito!",
                }).then(() => {
                    // Ejecutar onGoBack cuando el usuario haz clic en OK
                    onGoBack();
                });
                fetchPatients();
            } else {
                console.error('Error al guardar los datos:', response.statusText);
            }
        } catch (error) {
            alertaGeneral({
                titulo: error.response?.data?.message || 'Error al crear el usuario',
                isError: true
            });
        }
    };

    const handleSelectChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    const [municipios, setMunicipios] = useState([]);

    const fetchMunicipios = async () => {
        try {
            const response = await apiClient.get(`/api/clinic/getMunicipios`);
            setMunicipios(response.data);
        } catch (error) {
            console.error('Error fetching municipios:', error);
        }
    };



    useEffect(() => {
        fetchMunicipios();
    }, []);

    const handleMunicipioChange = selectedOption => {
        setFormData({ ...formData, municipio: selectedOption.value });
    };


    const opcionesPaises = mapPaisesToSelectOptions(paises);
    const opcionesMunicipios = mapMunicipiosToSelectOptions(municipios);

    return (
        <Contenedor icon={Perfil} title="Agregar usuario">
            <div className="flex items-center justify-end mb-4">
                <button
                    type="submit"
                    className="button-gray"
                    onClick={onGoBack}
                >
                    Volver
                </button>
            </div>

            <form className="space-y-6" onSubmit={handleSubmit} encType="multipart/form-data">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

                    {/* Imagen */}
                    <div className="col-span-1">
                        <label className="form-label">Imagen</label>
                        <InputFile
                            name="foto_perfil"
                            fileName={formData.foto_perfil?.name}
                            onChange={handleChange}
                            accept="image/*"
                        />
                    </div>

                    {/* Documento (Adjuntar) */}
                    <div className="col-span-1">
                        <label className="form-label">Documento Identidad</label>
                        <InputFile
                            name="cedulaPDF"
                            fileName={formData.cedulaPDF?.name}
                            onChange={handleChange}
                            accept="application/pdf"
                        />
                    </div>

                    <div className="col-span-1">
                        <label className="form-label">Fecha de Nacimiento *</label>
                        <input
                            type="date"
                            name="dob"
                            value={formData.dob}
                            onChange={handleChange}
                            className="form-input"
                            required
                        />
                    </div>

                    {/* País de Nacimiento */}
                    <div className="form-group">
                        <label className="block text-gray-700">País de Nacimiento *</label>
                        <Select
                            name="birthCountry"
                            value={opcionesPaises.find(option => option.value === formData.birthCountry)}
                            onChange={(selectedOption) =>
                                setFormData({ ...formData, birthCountry: selectedOption.value })
                            }
                            options={opcionesPaises}
                            placeholder="Selecciona un país"
                            className="w-full"
                        />
                    </div>

                    {/* País de Residencia */}
                    <div className="form-group">
                        <label className="block text-gray-700">País de Residencia *</label>
                        <Select
                            name="residenceCountry"
                            value={opcionesPaises.find(option => option.value === formData.residenceCountry)}
                            onChange={(selectedOption) =>
                                setFormData({ ...formData, residenceCountry: selectedOption.value })
                            }
                            options={opcionesPaises}
                            placeholder="Selecciona un país"
                            className="w-full"
                        />
                    </div>

                    {/* Estado */}
                    <div className="form-group">
                        <label className="block text-gray-700">Municipio / Ciudad *</label>
                        <Select
                            name="municipio"
                            value={opcionesMunicipios.find(option => option.value === formData.residenceCountry)}
                            onChange={(selectedOption) =>
                                setFormData({ ...formData, municipio: selectedOption.value })
                            }
                            options={opcionesMunicipios}
                            placeholder="Selecciona un municipio"
                            className="w-full"
                        />
                    </div>

                    <div className="form-group">
                        <label className="block text-gray-700">Dirección</label>
                        <input
                            type="text"
                            name="address"
                            value={formData.address}
                            className="form-input"
                            placeholder="Dirección"
                            onChange={handleChange}
                        />
                    </div>


                    {/* Barrio */}
                    <div className="col-span-1">
                        <label className="form-label">Barrio *</label>
                        <input
                            type="text"
                            name="neighborhood"
                            value={formData.neighborhood}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Barrio"
                            required
                        />
                    </div>

                    <div className="col-span-1">
                        <label className="form-label">Zona de ubicación</label>
                        <select
                            name="zonaUbicacion"
                            value={formData.zonaUbicacion}
                            onChange={handleChange}
                            className="form-input"
                            required
                        >
                            <option value="">Selecciona una opción</option>
                            <option value="01_Rural">Rural</option>
                            <option value="02_Urbana">Urbana</option>
                        </select>
                    </div>


                    {/* Primer Nombre */}
                    <div className="col-span-1">
                        <label className="form-label">Primer Nombre *</label>
                        <input
                            type="text"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Primer Nombre"
                            required
                        />
                    </div>

                    {/* Segundo Nombre */}
                    <div className="col-span-1">
                        <label className="form-label">Segundo Nombre</label>
                        <input
                            type="text"
                            name="secondName"
                            value={formData.secondName}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Segundo Nombre"
                        />
                    </div>

                    {/* Primer Apellido */}
                    <div className="col-span-1">
                        <label className="form-label">Primer Apellido *</label>
                        <input
                            type="text"
                            name="firstLastName"
                            value={formData.firstLastName}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Primer Apellido"
                            required
                        />
                    </div>

                    {/* Segundo Apellido */}
                    <div className="col-span-1">
                        <label className="form-label">Segundo Apellido</label>
                        <input
                            type="text"
                            name="secondLastName"
                            value={formData.secondLastName}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Segundo Apellido"
                        />
                    </div>

                    {/* Género */}
                    <div className="col-span-1">
                        <label className="form-label">Grupo sanguíneo</label>
                        <select
                            name="grupoSanguineo"
                            value={formData.grupoSanguineo}
                            onChange={handleChange}
                            className="form-input"
                            required
                        >
                            <option value="">Selecciona una opción</option>
                            <option value="A">A</option>
                            <option value="B">B</option>
                            <option value="O">O</option>
                            <option value="AB">AB</option>
                        </select>
                    </div>
                    <div className="col-span-1">
                        <label className="form-label">RH</label>
                        <select
                            name="rh"
                            value={formData.rh}
                            onChange={handleChange}
                            className="form-input"
                            required
                        >

                            <option value="">Selecciona una opción</option>
                            <option value="Positivo">Positivo</option>
                            <option value="Negativo">Negativo</option>
                        </select>
                    </div>
                    <div className="col-span-1">
                        <label className="form-label">Género *</label>
                        <select
                            name="gender"
                            value={formData.gender}
                            onChange={handleChange}
                            className="form-input"
                            required
                        >
                            <option value="" disabled>Selecciona un género</option>
                            <option value="Masculino">Masculino</option>
                            <option value="Femenino">Femenino</option>
                            <option value="no-binario">No Binario</option>
                            <option value="Otro">Otro</option>
                            <option value="prefiero-no-decirlo">Prefiero no decirlo</option>
                        </select>
                    </div>
                    <div className="col-span-1">
                        <label className="form-label">Sexo</label>
                        <select
                            name="sex"
                            value={formData.sex}
                            onChange={handleChange}
                            className="form-input"
                            required
                        >
                            <option value="">Selecciona una opción</option>
                            <option value="H">Hombre</option>
                            <option value="M">Mujer</option>
                            <option value="I">Indeterminado/Intersexual</option>
                        </select>
                    </div>
                    <div className="col-span-1">
                        <label className="form-label">Estado civil</label>
                        <select
                            name="estadoCivil"
                            value={formData.estadoCivil}
                            onChange={handleChange}
                            className="form-input"
                            required
                        >
                            <option value="">Selecciona una opción</option>
                            <option value="Soltero">Soltero(A)</option>
                            <option value="Casado">Casado(A)</option>
                            <option value="Viudo">Viudo(A)</option>
                            <option value="Divorciado">Divorciado(A)</option>
                            <option value="Separado">Separado(A)</option>
                            <option value="Unión Libre">Unión Libre</option>
                            <option value="No Aplica">No Aplica</option>
                        </select>
                    </div>
                    <div className="col-span-1">
                        <label className="form-label">Condición de desplazamiento</label>
                        <select
                            name="condicionDesplazamiento"
                            value={formData.condicionDesplazamiento}
                            onChange={handleChange}
                            className="form-input"
                            required
                        >
                            <option value="">Selecciona una opción</option>
                            <option value="Desplazados internos">Desplazados internos</option>
                            <option value="Poblacion desplazada por la violencia">Población desplazada por la violencia</option>
                            <option value="Desplazamiento forzado">Desplazamiento forzado</option>
                            <option value="No aplica">No aplica</option>
                        </select>
                    </div>
                    <div className="col-span-1">
                        <label className="form-label">Grupo étnico</label>
                        <select
                            name="grupoEtnico"
                            value={formData.grupoEtnico}
                            onChange={handleChange}
                            className="form-input"
                            required
                        >
                            <option value="">Selecciona un grupo étnico</option>
                            <option value="ROM (GITANOS)">ROM (GITANOS)</option>
                            <option value="AFROCOLOMBIANOS">AFROCOLOMBIANOS (Negro(a), mulato(a), afro colombiano(a) o afro descendiente)</option>
                            <option value="INDIGENAS">INDÍGENAS</option>
                            <option value="RAIZALES">RAIZALES (del archipiélago de San Andrés y Providencia)</option>
                            <option value="PALENQUERO">PALENQUERO (de San Basilio)</option>
                            <option value="Sin pertenencia étnica">Sin pertenencia étnica</option>
                        </select>
                    </div>
                    <div className="col-span-1">
                        <label className="form-label">Escolaridad</label>
                        <select
                            name="escolaridad"
                            value={formData.escolaridad}
                            onChange={handleChange}
                            className="form-input"
                            required
                        >
                            <option value="">Selecciona una opción</option>
                            <option value="Básica Primaria">Básica Primaria</option>
                            <option value="Básica Secundaria">Básica Secundaria</option>
                            <option value="Técnica Profesional">Técnica Profesional</option>
                            <option value="Profesional">Profesional</option>
                            <option value="Especialización">Especialización</option>
                            <option value="Ninguno">Ninguno</option>
                            <option value="Otro">Otro</option>
                            <option value="Preescolar">Preescolar</option>
                            <option value="Media Académica o Clásica">Media Académica o Clásica</option>
                            <option value="Media Técnica (Bachillerato Técnico)">Media Técnica (Bachillerato Técnico)</option>
                            <option value="Normalista">Normalista</option>
                            <option value="Tecnológica">Tecnológica</option>
                            <option value="Maestría">Maestría</option>
                            <option value="Doctorado">Doctorado</option>
                            <option value="Posgrado">Posgrado</option>
                        </select>
                    </div>

                    {/* Número de Celular */}
                    <div className="col-span-1">
                        <label className="form-label">Número de Celular *</label>
                        <input
                            type="text"
                            name="cellNumber"
                            value={formData.cellNumber}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Número de Celular"
                            required
                        />
                    </div>
                    <div className="col-span-1">
                        <label className="form-label">Número de Celular 2</label>
                        <input
                            type="text"
                            name="cellNumber1"
                            value={formData.cellNumber1}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Número de Celular"

                        />
                    </div>

                    {/* Correo Electrónico */}
                    <div className="col-span-1">
                        <label className="form-label">Correo Electrónico *</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Correo Electrónico"
                            required
                        />
                    </div>

                    {/* Tipo de ID */}
                    <div className="col-span-1">
                        <label className="form-label">Tipo de ID *</label>
                        <select
                            name="idType"
                            value={formData.idType}
                            onChange={handleSelectChange}
                            className="form-input"
                            required
                        >
                            <option value="">Selecciona</option>
                            <option value="CC">CC</option>
                            <option value="TI">TI</option>
                            <option value="CE">CE</option>
                            <option value="PS">PS</option>
                            <option value="DE">DE</option>
                        </select>
                    </div>

                    {/* Número de ID */}
                    <div className="col-span-1">
                        <label className="form-label">Número de ID *</label>
                        <input
                            type="text"
                            name="idNumber"
                            value={formData.idNumber}
                            onChange={handleChange}
                            className="form-input"
                            placeholder="Número de ID"
                            required
                        />
                    </div>
                    <div className="col-span-1">
                        <label className="form-label">Tipo de usuario</label>
                        <select
                            name="tipoUsuario"
                            value={formData.tipoUsuario}
                            onChange={handleSelectChange}
                            className="form-input"
                            required
                        >
                            <option value="">Selecciona un tipo de usuario</option>
                            <option value="01">Contributivo cotizante</option>
                            <option value="02">Contributivo beneficiario</option>
                            <option value="03">Contributivo adicional</option>
                            <option value="04">Subsidiado</option>
                            <option value="05">No afiliado</option>
                            <option value="06">Especial o Excepción cotizante</option>
                            <option value="07">Especial o Excepción beneficiario</option>
                            <option value="08">Personas privadas de la libertad a cargo del Fondo Nacional de Salud</option>
                            <option value="09">Tomador / Amparado ARL</option>
                            <option value="10">Tomador / Amparado SOAT</option>
                            <option value="11">Tomador / Amparado Planes voluntarios de salud</option>
                            <option value="12">Particular</option>
                        </select>
                    </div>

                    <div className="col-span-1">
                        <label className="form-label">Ocupación</label>
                        <Select
                            name="ocupacion"
                            value={selectedOcupacion}
                            onChange={handleOcupacionChange}
                            onInputChange={(inputValue) => {
                                if (inputValue.length > 2) {
                                    fetchOcupacionOptions(inputValue);
                                } else {
                                    setOcupacionOptions([]); // Limpiar las opciones si el input es corto
                                }
                            }}
                            options={ocupacionOptions}
                            isLoading={loading}
                            className="mt-1 block w-full"
                            placeholder="Buscar..."
                        />
                    </div>
                    <div className="col-span-1">
                        <label className="form-label">Aseguradora</label>
                        <Select
                            name="aseguradora"
                            value={selectedAseguradora}
                            onChange={handleAseguradoraChange}
                            onInputChange={(inputValue) => {
                                if (inputValue.length > 2) {
                                    fetchAseguradoraOptions(inputValue);
                                } else {
                                    setAseguradoraOptions([]); // Limpiar las opciones si el input es corto
                                }
                            }}
                            options={aseguradoraOptions}
                            isLoading={loading}
                            className="mt-1 block w-full"
                            placeholder="Buscar..."
                        />
                    </div>
                </div>

                <hr className="my-6 border-gray-300" />

                {/* Seguro Médico */}
                <div className="col-span-1">
                    <label className="form-label">¿Tiene Seguro Médico?</label>
                    <select
                        name="hasMedicalInsurance"
                        value={formData.hasMedicalInsurance}
                        onChange={handleSelectChange}
                        className="form-input"
                    >
                        <option value="no">No</option>
                        <option value="yes">Sí</option>
                    </select>
                </div>

                {formData.hasMedicalInsurance === 'yes' && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                        {/* Nombre del Seguro */}
                        <div className="col-span-1">
                            <label className="form-label">Nombre del Seguro</label>
                            <input
                                type="text"
                                name="insuranceName"
                                value={formData.insuranceName}
                                onChange={handleChange}
                                className="form-input"
                                placeholder="Nombre del Seguro"
                            />
                        </div>

                        {/* Número del Seguro */}
                        <div className="col-span-1">
                            <label className="form-label">Número del Seguro</label>
                            <input
                                type="text"
                                name="insuranceNumber"
                                value={formData.insuranceNumber}
                                onChange={handleChange}
                                className="form-input"
                                placeholder="Número del Seguro"
                            />
                        </div>
                    </div>
                )}

                {/* Cuidador o Representante */}
                <div className="col-span-1">
                    <label className="form-label">¿Tiene Cuidador o Representante?</label>
                    <select
                        name="hasCarer"
                        value={formData.hasCarer}
                        onChange={handleSelectChange}
                        className="form-input"
                    >
                        <option value="no">No</option>
                        <option value="yes">Sí</option>
                    </select>
                </div>

                {formData.hasCarer === 'yes' && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                        {/* Primer Nombre del Cuidador */}
                        <div className="col-span-1">
                            <label className="form-label">Primer Nombre del Cuidador</label>
                            <input
                                type="text"
                                name="carerFirstName"
                                value={formData.carerFirstName}
                                onChange={handleChange}
                                className="form-input"
                                placeholder="Primer Nombre del Cuidador"
                            />
                        </div>

                        {/* Segundo Nombre del Cuidador */}
                        <div className="col-span-1">
                            <label className="form-label">Segundo Nombre del Cuidador</label>
                            <input
                                type="text"
                                name="carerSecondName"
                                value={formData.carerSecondName}
                                onChange={handleChange}
                                className="form-input"
                                placeholder="Segundo Nombre del Cuidador"
                            />
                        </div>

                        {/* Primer Apellido del Cuidador */}
                        <div className="col-span-1">
                            <label className="form-label">Primer Apellido del Cuidador</label>
                            <input
                                type="text"
                                name="carerFirstLastName"
                                value={formData.carerFirstLastName}
                                onChange={handleChange}
                                className="form-input"
                                placeholder="Primer Apellido del Cuidador"
                            />
                        </div>

                        {/* Segundo Apellido del Cuidador */}
                        <div className="col-span-1">
                            <label className="form-label">Segundo Apellido del Cuidador</label>
                            <input
                                type="text"
                                name="carerSecondLastName"
                                value={formData.carerSecondLastName}
                                onChange={handleChange}
                                className="form-input"
                                placeholder="Segundo Apellido del Cuidador"
                            />
                        </div>

                        {/* Parentesco */}
                        <div className="col-span-1">
                            <label className="form-label">Parentesco</label>
                            <input
                                type="text"
                                name="carerRelationship"
                                value={formData.carerRelationship}
                                onChange={handleChange}
                                className="form-input"
                                placeholder="Parentesco"
                            />
                        </div>

                        {/* Tipo de ID del Cuidador */}
                        <div className="col-span-1">
                            <label className="form-label">Tipo de ID del Cuidador</label>
                            <select
                                name="carerIdType"
                                value={formData.carerIdType}
                                onChange={handleSelectChange}
                                className="form-input"
                            >
                                <option value="">Selecciona</option>
                                <option value="CC">CC</option>
                                <option value="TI">TI</option>
                                <option value="CE">CE</option>
                                <option value="PS">PS</option>
                                <option value="DE">DE</option>
                            </select>
                        </div>

                        {/* Número de ID del Cuidador */}
                        <div className="col-span-1">
                            <label className="form-label">Número de ID del Cuidador</label>
                            <input
                                type="text"
                                name="carerIdNumber"
                                value={formData.carerIdNumber}
                                onChange={handleChange}
                                className="form-input"
                                placeholder="Número de ID del Cuidador"
                            />
                        </div>
                    </div>
                )}

                <div className="flex justify-end mt-4">
                    <button
                        type="submit"
                        className="button-send"
                    >
                        Guardar
                    </button>
                </div>
            </form>
        </Contenedor>
    );
}

export default PatientComponent;
